import isPlainObject from 'lodash/isPlainObject';

import Admin from 'hive-admin';
import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

// import Types from '../../common/modules/types';
import tests from '../../helpers/tests';
import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createChangeLogSection } from '../../components/FieldChangeLog';

import { fieldI18nLanguage } from '../../helpers/i18n';

import Types from '../../modules/types';

Admin.addToLibrary('validation.isJsonString', ({
  checkResult = isPlainObject,
  ...restConfig
// eslint-disable-next-line no-unused-vars
} = {}) => props => ({
  validator: (rule, value, cb) => {
    try {
      const result = JSON.parse(value);
      if (!checkResult || checkResult(result)) {
        cb();
      } else {
        cb(rule.message);
      }
    } catch (error) {
      cb(rule.message);
    }
  },
  message: 'Invalid JSON!',
  ...restConfig,
}));

export const fieldName = ['FieldText', {
  name: 'name',
  label: null,
  prefix: 'Name:',
  rules: [
    ['validation.isRequired'],
  ],
}];

export const fieldImage = ['FieldUploadRefs', {
  name: 'image',
  label: null,
  accept: 'image/jpg,image/jpeg,image/png,image/svg+xml,image/webp',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 1024 }],
    ['GM', { command: 'webp' }],
  ],
  listType: 'picture-card',
  uploadLabel: 'Image',
  maxCount: 1,
}];

export const fieldDescription = ['FieldTextArea', {
  name: 'description',
  label: null,
  // eslint-disable-next-line max-len
  placeholder: 'Description',
  autoSize: { minRows: 3 },
}];

export const fieldInternal = ['FieldRadio', {
  name: 'internal',
  label: null,
  initialValue: true,
  choices: [{
    label: 'Public',
    value: false,
  }, {
    label: 'Internal',
    value: true,
  }],
  block: true,
}];

export const fieldKind = ['FieldRadio', {
  name: 'kind',
  label: null,
  initialValue: 'ELEMENT',
  choices: [{
    label: 'Element',
    value: 'ELEMENT',
  }, {
    label: 'Section',
    value: 'SECTION',
  }, {
    label: 'Template',
    value: 'TEMPLATE',
  }],
  block: true,
  virtual: [tests.activityIsNotCreate],
  disabled: [tests.activityIsNotCreate],
}];

export const fieldPreviewLink = ['FieldText', {
  name: 'previewLink',
  label: null,
  prefix: 'Preview Link:',
  skip: [
    [
      'condition.testFieldValue',
      'kind',
      '!==',
      'TEMPLATE',
    ],
  ],
}];

export const fieldPreviewStore = ['FieldConnectionSelect', {
  name: 'previewStore',
  label: null,
  url: '/stores/list',
  allowClear: true,
  searchPaths: ['name'],
  prefix: 'Preview Store:',
  skip: [
    [
      'condition.testFieldValue',
      'kind',
      '!==',
      'TEMPLATE',
    ],
  ],
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the store',
  label: null,
  prefix: 'Store:',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [
    tests.activityIsNotCreate,
    Admin.compileFromLibrary([
      'condition.testFieldValue',
      'store',
      (v1) => !!v1,
    ]),
  ],
  virtual: [tests.activityIsNotCreate],
  hidden: [tests.viewerIsNotAdmin],
  getInitialValue: (fieldConfig, formProps) => (
      formProps?.data?.store
    ? formProps.data.store
    : formProps?.viewer?.role === 'SELLER'
    ? formProps.viewer?.store
    : null
  ),
}];

export const fieldContent = ['FieldContentBuilderItems', {
  name: 'content',
}];

export const fieldFieldsComponents = ['FieldSortableList', {
  label: null,
  name: 'fields',
  addButtonLabel: 'Add Field',
  shouldRenderPlaceholder: true,
  condensed: true,
  collapseFieldName: '__collapsed',
  collapseLabelDefault: '',
  supportPaste: true,
  pasteRealm: 'ContentBuilderComponent:Field',
  pasteButtonLabel: 'Paste Field',
  fields: [
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'name',
      placeholder: 'Label',
    }], 12),
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'id',
      prefix: 'Field ID:',
      placeholder: 'Field ID',
      rules: [
        ['validation.isRequired'],
      ],
    }], 12),
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'fieldType',
      prefix: 'Field Type:',
      rules: [
        ['validation.isRequired'],
      ],
    }], 24),
    // getFilterWithCol(['FieldText', {
    //   label: null,
    //   name: 'type',
    //   prefix: 'Value Type:',
    //   rules: [
    //     ['validation.isRequired'],
    //   ],
    // }], 12),
    ['FieldCodeEditor', {
      label: null,
      name: 'fieldConfig',
      defaultLanguage: 'json',
      initialValue: '{}',
      minHeight: '180px',
      prepareValueForInput: value => (
          isPlainObject(value)
        ? JSON.stringify(value, null, '  ')
        : value
      ),
      rules: [
        ['validation.isRequired'],
        ['validation.isJsonString'],
      ],
    }],
    ['FieldSortableList', {
      label: null,
      name: 'targets',
      addButtonLabel: 'Add Field Target',
      // shouldRenderPlaceholder: true,
      condensed: true,
      head: 'horizontal',
      supportPaste: true,
      pasteRealm: 'ContentBuilderComponent:Field',
      pasteButtonLabel: 'Paste Field Target',
      // eslint-disable-next-line no-unused-vars
      getPastePayload: (payload, props, field) => ({
        value: payload?.targets?.[0]?.value,
      }),
      fields: [
        ['FieldText', {
          label: null,
          name: 'value',
          placeholder: 'Target',
        }],
      ],
    }],
  ],
}];

export const fieldFieldsLibrary = ['FieldSortableList', {
  label: null,
  name: 'fields',
  addButtonLabel: 'Add Field',
  shouldRenderPlaceholder: true,
  condensed: true,
  collapseFieldName: '__collapsed',
  collapseLabelDefault: '',
  supportPaste: true,
  pasteRealm: 'ContentBuilderLibrary:Field',
  pasteButtonLabel: 'Paste Field',
  fields: [
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'id',
      prefix: 'Field ID:',
      placeholder: 'Field ID',
      rules: [
        ['validation.isRequired'],
      ],
    }], 12),
    getFilterWithCol(['FieldSelect', {
      label: null,
      name: 'type',
      prefix: 'Type:',
      initialValue: Types.CONTENT_BUILDER_LIBRARY_FIELD_TYPE[0],
      choices: Types.CONTENT_BUILDER_LIBRARY_FIELD_TYPE_ITEMS.map((item) => ({
        value: item.id,
        label: item.label,
      })),
    }], 12),
    ['FieldSortableList', {
      label: null,
      name: 'targets',
      addButtonLabel: 'Add Field Target',
      // shouldRenderPlaceholder: true,
      condensed: true,
      head: 'horizontal',
      supportPaste: true,
      pasteRealm: 'ContentBuilderLibrary:Field',
      pasteButtonLabel: 'Paste Field Target',
      // eslint-disable-next-line no-unused-vars
      getPastePayload: (payload, props, field) => ({
        value: payload?.targets?.[0]?.value,
      }),
      fields: [
        ['FieldText', {
          label: null,
          name: 'value',
          placeholder: 'Target',
        }],
      ],
    }],
  ],
}];

export const fieldAssets = ['FieldUploadRefsHorizontal', {
  name: 'assets',
  label: 'Assets',
  accept: '*/*',
  transformations: [],
  listType: 'picture',
  uploadLabel: 'Upload Assets',
  hidden: [['condition.fieldIsNotTrue', 'showAdvanced']],
  maxCount: 50,
}];

export const fieldCustomCss = ['FieldCodeEditor', {
  name: 'customCss',
  label: 'Custom CSS',
  placeholder: '',
  defaultLanguage: 'css',
  minHeight: '600px',
  hidden: [['condition.fieldIsNotTrue', 'showAdvanced']],
}];

export const COMPONENTS = [
  fieldI18nLanguage,
  fieldName,
  ['FieldTitle', {
    title: 'Content',
  }],
  fieldContent,
  ['FieldTitle', {
    title: 'Fields',
  }],
  fieldFieldsComponents,
  asLocalStorageField(['FieldTitleToggle', {
    title: 'Advanced',
    name: 'showAdvanced',
    size: 'medium',
    initialValue: false,
  }]),
  fieldAssets,
  fieldCustomCss,

  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: { EQ: null },
        'target.type': 'ContentBuilderSegment',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const BLOCKS = [
  fieldI18nLanguage,
  fieldName,
  fieldStore,
  ['FieldTitle', {
    title: 'Content',
  }],
  fieldContent,

  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'ContentBuilderSegment',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const LIBRARY = [
  fieldI18nLanguage,
  fieldImage,
  fieldName,
  fieldInternal,
  fieldPreviewStore,
  fieldPreviewLink,
  fieldKind,
  fieldDescription,
  ['FieldTitle', {
    title: 'Content',
  }],
  fieldContent,
  ['FieldTitle', {
    title: 'Fields',
  }],
  fieldFieldsLibrary,

  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: { EQ: null },
        'target.type': 'ContentBuilderSegment',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];
